module.exports = __webpack_public_path__ + "static/media/women_only.37d73b20.jpg";